import * as React from 'react';
import CompanyListDataGrid from './CompanyListDataGrid';

function Nasdaq100Ranking({data} :any) {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/leaderboard">Leader Board</a></li>
            <li className="breadcrumb-item active" aria-current="page">Ranking of Nasdaq 100 Companies</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Ranking of Nasdaq 100 Companies</h4>
              <p className="card-description">
                We ranked all Nasdaq 100 companies by analyzing 10 years of their financial records using tried and true value investing principles.

                Use this list as a start in finding your next great investment. Remember to do your own research before investing in any company. Check out our guide on <a href="https://decode-investing.medium.com/how-to-identify-a-wonderful-business-6f7afdc6a5c6">How to Identify a Wonderful Business</a>.
              </p>
              <h5>Related:</h5>
              <ul>
                <li><a href='/s_and_p_500'>Ranking of S&P 500 companies (Large-Cap companies)</a></li>
                <li><a href='/s_and_p_400'>Ranking of S&P 400 (Mid-Cap companies)</a></li>
                <li><a href='/russell_2000'>Highest ranked companies on Russell 2000 (Small-Cap companies)</a></li>
              </ul>
              <div>
                <CompanyListDataGrid
                  data={data}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nasdaq100Ranking;
